import { SCORE_COLUMNS } from '@/types/filterKeyConst';

const scoreList = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

const scoreFilterItemFetcher = async (
  columnKey: string,
  params?: StructuredColumnFetcherParams,
) => {
  return scoreList
    .filter((score) => {
      if (!params?.searchValue) return true;
      return String(score).includes(params.searchValue);
    })
    .map((score) => ({
      columnKey: columnKey,
      filterKey: score,
      filterName: String(score),
      filterOptionNode: String(score),
    }));
};

export const useScoreFilterMap = () => {
  const fieldOptions: StructuredFieldOptionMap = {
    [SCORE_COLUMNS.RATING_SCORE]: {
      columnKey: SCORE_COLUMNS.RATING_SCORE,
      columnName: 'Rating Score',
      isMultiValueField: false,
      filterItemOptions: {
        type: 'select',
        filterItemFetcher: async (params) => {
          return scoreFilterItemFetcher(SCORE_COLUMNS.RATING_SCORE, params);
        },
      },
    },
    [SCORE_COLUMNS.NPS_SCORE]: {
      columnKey: SCORE_COLUMNS.NPS_SCORE,
      columnName: 'NPS Score',
      isMultiValueField: false,
      filterItemOptions: {
        type: 'select',
        filterItemFetcher: async (params) => {
          return scoreFilterItemFetcher(SCORE_COLUMNS.NPS_SCORE, params);
        },
      },
    },
    [SCORE_COLUMNS.CES_SCORE]: {
      columnKey: SCORE_COLUMNS.CES_SCORE,
      columnName: 'CES Score',
      isMultiValueField: false,
      filterItemOptions: {
        type: 'select',
        filterItemFetcher: async (params) => {
          return scoreFilterItemFetcher(SCORE_COLUMNS.CES_SCORE, params);
        },
      },
    },
    [SCORE_COLUMNS.CSAT_SCORE]: {
      columnKey: SCORE_COLUMNS.CSAT_SCORE,
      columnName: 'CSAT Score',
      isMultiValueField: false,
      filterItemOptions: {
        type: 'select',
        filterItemFetcher: async (params) => {
          return scoreFilterItemFetcher(SCORE_COLUMNS.CSAT_SCORE, params);
        },
      },
    },
  };

  return fieldOptions;
};
